import { SnackbarProvider } from "notistack";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthProvider";
import { CssBaseline } from "@mui/material";
import { RouterProvider } from "./Routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 5 * 1000,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SnackbarProvider
          maxSnack={3}
          preventDuplicate
          anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
          autoHideDuration={5000}
          style={{
            padding: '20px 20px',
            backgroundColor: '#333',
          }}
        >
          <CssBaseline />
          <RouterProvider />
        </SnackbarProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};
export default App;
